



  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Piscines"
})
export default class Piscines extends Vue {}
